/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'extension.charts.aggregateData': 'Aggreger data',
  'extension.charts.aggregateDataDescription':
    'Kombiner værdier i et enkelt datapunkt, når flere rækker har den samme værdi.',
  'extension.charts.category': 'Kategori',
  'extension.charts.customizeTab': 'Tilpas',
  'extension.charts.dataMissing.details': 'Vi kan ikke finde dette diagrams kildetabel på siden.',
  'extension.charts.dataMissing.title': 'Der er ingen data til visning',
  'extension.charts.dataTab': 'Data',
  'extension.charts.defaultColumnName': 'Kolonne {0}',
  'extension.charts.defaultTitle': 'Diagram uden titel',
  'extension.charts.defaultYLabel': 'Akse uden titel',
  'extension.charts.extensionTitle': 'Diagram',
  'extension.charts.height': 'Diagramhøjde',
  'extension.charts.height.large': 'Højere',
  'extension.charts.height.medium': 'Standard',
  'extension.charts.height.small': 'Lavere',
  'extension.charts.horizontal.orientation.label': 'Vandret',
  'extension.charts.insert.tooltip': 'Indsæt diagram',
  'extension.charts.legend': 'Tegnforklaring',
  'extension.charts.legend.auto': 'Automatisk',
  'extension.charts.legend.bottom': 'Forneden',
  'extension.charts.legend.left': 'Til venstre',
  'extension.charts.legend.position': 'Placering af tegnforklaring',
  'extension.charts.legend.right': 'Til højre',
  'extension.charts.legend.show': 'Vis tegnforklaring',
  'extension.charts.legend.top': 'Foroven',
  'extension.charts.options.label': 'Indstillinger for diagram',
  'extension.charts.options.tooltip': 'Skift indstillinger for diagram',
  'extension.charts.orientation.label': 'Orientering',
  'extension.charts.seriesNames': 'Dataserier',
  'extension.charts.showPoints': 'Vis datapunkter',
  'extension.charts.smoothLines': 'Glatte linjer',
  'extension.charts.style': 'Stil',
  'extension.charts.title': 'Titel',
  'extension.charts.type.bar': 'Søjle',
  'extension.charts.type.fieldDescription': 'Diagramtype',
  'extension.charts.type.line': 'Linje',
  'extension.charts.type.pie': 'Lagkage',
  'extension.charts.userTitle': 'Titel',
  'extension.charts.vertical.orientation.label': 'Lodret',
  'extension.charts.xAxis': 'X-akse',
  'extension.charts.xLabel': 'Etiket for X-akse',
  'extension.charts.yLabel': 'Etiket for Y-akse',
};
